<template>
    <div>
        <vs-popup class="add-custom-list-popup" title="" :active.sync="addCustomListPopupActive">
            <div class="vx-row flex-wrap" style="justify-content: space-between; align-items:center">
                <h3>Add Custom List</h3>

            </div>

            <hr style=" margin: auto; margin-top: 2rem; border-top: 0.5px solid #FAFAFA;">

            <div style="padding: 15px;">
                <h4 class="mb-4 inline-flex section-title">Partner Details</h4>
                <div class="vx-row m0">
                    <div class="flex w-auto">
                        <div class="vx-col w-full mb-2 form-field">
                            <label class="vs-input--label inline-flex pb-2">Partner Name</label>
                            <vs-input disabled class="inputx w-full" v-model="partnerDetails.name" />
                            <span class="text-danger text-sm" v-show="errors.has('partnerName')">Required field</span>
                        </div>

                        <div class="vx-col w-full mb-2 form-field">
                            <label class="vs-input--label inline-flex pb-2">Type</label>
                            <v-select name="type" class="w-full" v-model="partnerDetails.type" :options="formInit['types']" :multiple="false" :closeOnSelect="true" v-validate="'required'" data-vv-validate-on="change" disabled></v-select>
                            <span class="text-danger text-sm" v-show="errors.has('type')">Required field</span>
                        </div>

                        <div class="vx-col w-full mb-2 form-field">
                            <label class="vs-input--label inline-flex pb-2">Payment Mode</label>
                            <vs-input class="inputx w-full" v-model="partnerDetails.website" />
                            <span class="text-danger text-sm" v-show="errors.has('website')">Required field</span>
                        </div>

                        <div class="vx-col w-full mb-2 form-field">
                            <label class="vs-input--label inline-flex pb-2">Currency</label>
                            <vs-input class="inputx w-full" v-model="partnerDetails.currency" />
                            <span class="text-danger text-sm" v-show="errors.has('website')">Required field</span>
                        </div>

                    </div>
                </div>

                <div class="vx-row m0">
                    <div class="flex w-auto" v-for="(poc, index) in partnerDetails.poc" :key="`'poc'-${index}`">
                        <div class="vx-col w-full mb-2 form-field" v-if="index === 0">
                            <label class="vs-input--label inline-flex pb-2">Account Manager</label>
                            <vs-input class="inputx w-full" v-model="partnerDetails.am" />
                            <span class="text-danger text-sm" v-show="errors.has('currencyType')">Required field</span>
                        </div>

                        <div class="vx-col w-full mb-2 form-field">
                            <label class="vs-input--label inline-flex pb-2">POC {{ index + 1 }} Name</label>
                            <vs-input class="inputx w-full" v-model="poc.name" />
                            <span class="text-danger text-sm" v-show="errors.has('name')">Required field</span>
                        </div>

                        <div class="vx-col w-full mb-2 form-field">
                            <label class="vs-input--label inline-flex pb-2">POC {{ index + 1 }} Email</label>
                            <vs-input class="inputx w-full" v-model="poc.email" />
                            <span class="text-danger text-sm" v-show="errors.has('email')">Required field</span>
                        </div>

                    </div>
                </div>
            </div>

            <div style="padding: 15px;">
                <h4 class="mt-4 mb-4 inline-flex section-title">Upload Files</h4>
                <div class="vx-row m0">
                    <div class="flex w-auto">
                        <div class="vx-col mb-2 form-field" style="margin: 5px;">
                            <label class="vs-input--label inline-flex pb-2">Custom List File</label>
                            <div class="upload-input relative">
                                <input name="uploadListFile" type="file" id="customListUploadFile" ref="customListUploadFile" style="cursor: pointer; padding: 2rem;" v-validate="!imgLoaded ? 'required' : ''" class="absolute top-0 left-0 w-full h-full z-10 opacity-0" @change="handleFileChange()" />
                                <vs-button class="mt-2 upload-btn" type="filled" icon-pack="feather" icon="icon-file">Drag & Drop Excel/CSV File Here</vs-button>
                                <span class="text-danger text-sm" v-show="errors.has('uploadListFile')">Required field</span>
                                <div class="file-errors-wrap flex flex-wrap">
                                    <ul v-show="formData['fileName']" class="pt-2 pr-5">
                                        <li class="flex items-center">
                                            <p class="pr-1" :class=" formData['fileTypeError'] || formData['fileSizeError'] ? 'color-gray' : 'text-primary' ">
                                                {{ formData["fileName"] }}
                                            </p>
                                            <!-- Hide remove icon if filesize or filetype error is there. -->
                                            <vs-button v-show=" !formData['fileTypeError'] && !formData['fileSizeError'] " color="danger" type="flat" icon-pack="feather" icon="icon-x" class="remove-agt-file-btn" @click="removeFile()"></vs-button>
                                        </li>
                                    </ul>
                                    <p v-show="formData['fileTypeError']" class="pt-2 text-danger">
                                        {{ formData["fileTypeError"] }}
                                    </p>
                                    <p v-show="formData['fileSizeError']" class="pt-2 text-danger">
                                        {{ formData["fileSizeError"] }}
                                    </p>
                                </div>
                            </div>
                            <p style="font-size:9px;display:flex" class="mt-3">
                                <feather-icon icon="FileIcon" color="primary" class="primary" style="width:13px;height:13px;color:#0142F8" /> <u><a href='/path/to/excel/file.xls' target="_blank">Click Here To Download Sample Rebate List Format</a></u>
                            </p> <br>
                        </div>
                    </div>
                </div>
            </div>

            <hr style=" margin: auto; margin-top: 2rem; border-top: 0.5px solid #FAFAFA;">

            <div class="flex justify-end pb-4 pr-4 pt-2 mt-5">
                <vs-button color="primary" type="filled" class="action-btn" @click="onSubmit()">Save</vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from "vue-select";

export default {
    name: "AddCustomList",
    components: {
        "v-select": vSelect,
    },
    data() {
        return this.initData();
    },
    mounted() {
        this.$root.$on("openAddCustomList", () => {
            this.addCustomListPopupActive = true;
        });
    },
    destroyed() {
        this.$root.$off("openAddCustomList");
    },
    methods: {
        initData() {
            return {
                addCustomListPopupActive: false,
                partnerDetails: {
                    name: "GoDaddy Inc.",
                    type: ["Registrar"],
                    website: "www.godaddy.com",
                    am: "Neha Naik",
                    poc: [
                        {
                            name: "John Doe",
                            email: "john@godaddy.com",
                        },
                        {
                            name: "Mike Smith",
                            email: "mike@godaddy.com",
                        },
                        {
                            name: "Molly Adams",
                            email: "molly@godaddy.com",
                        },
                    ],
                },
                paymentDetails: {
                    paymentMode: ["Direct"],
                    currency: ["USD - $"],
                    listBased: ["Yes", "No", "Both"],
                    listFrequency: ["Monthly", "Quarterly"],
                    customList: ["Yes", "No"],
                    cnicId: "",
                    bank: "",
                    bankACNo: "0000 0000 0000",
                    swiftCode: "AB00000",
                },
                formInit: {
                    types: ["Registrar", "Reseller"],
                },
                formData: {
                    period: "",
                    fileTypeError: "",
                    fileSizeError: "",
                    fileName: "",
                    filePath: "",
                    fileExtension: "",
                },
                imgLoaded: false,
            };
        },
        onSubmit() {
            var self = this;
            self.$axiosSecure
                .put("/client-config-details/{$id}")
                .then((response) => {
                    // self.$vs.notify({
                    //     color: "primary",
                    //     title: "Updated Details Submitted",
                    //     text: "Your request to update GoDaddy's details have been submitted to the Administrator. When approved, the update will be made automatically. \n\n Thank You.",
                    // });

                    self.$vs.dialog({
                        color: "primary",
                        title: "Updated Details Submitted",
                        text: "Your request to update GoDaddy's details have been submitted to the Administrator. When approved, the update will be made automatically. \n\n\nThank You.",
                        acceptText: "Okay",
                        accept: () => {
                            // this.$router.push({ path: "/agreement-list" });
                        },
                    });
                })
                .catch((error) => {
                    // Error notification
                    // self.$vs.notify({
                    //     color: "primary",
                    //     title: "Updated Details Submitted",
                    //     text: "Your request to update GoDaddy's details have been submitted to the Administrator. When approved, the update will be made automatically. \n\n Thank You.",
                    // });

                    self.$vs.dialog({
                        color: "primary",
                        title: "Updated Details Submitted",
                        text: "Your request to update GoDaddy's details have been submitted to the Administrator. When approved, the update will be made automatically. \n\n\nThank You.",
                        acceptText: "Okay",
                        accept: () => {
                            // this.$router.push({ path: "/agreement-list" });
                        },
                    });
                    console.log(error);
                });
        },
    },
};
</script>

<style>
</style>